<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title">
        {{ 'favorites.create.dialog.title' | cxTranslate }}
      </div>
      <button
        type="button"
        class="close"
        [attr.aria-label]="'common.close' | cxTranslate"
        (click)="dismissModal('Cross click')"
      >
        <span aria-hidden="true">
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </span>
      </button>
    </div>
    <div class="eb-favorites-create-dialog__error">
      <cx-global-message></cx-global-message>
    </div>
    <!-- Modal Body -->
    <div class="cx-dialog-body modal-body">
      <div class="cx-dialog-row row">
        <div class="cx-dialog-item col-12">
          <eb-form
            [formConfig]="formConfig"
            context="favorites.create"
            (formSubmit)="onSubmit($event)"
            [submitting]="submitting$ | async"
            [hideTitle]="true"
          >
            <a class="eb-favorites-create-dialog__cancel" (click)="dismissModal('cancel')">
              {{ 'favorites.create.dialog.cancel' | cxTranslate }}
            </a>
          </eb-form>
        </div>
      </div>
    </div>
  </div>
</div>
